import { Component, ElementRef, Inject, Injector } from "@angular/core";
import { NgbActiveModal, NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FormGroup, FormControl, FormBuilder, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import * as jQuery from "jquery";
import { DataService } from "../../../services/data/data.service";
import { LoginRequestModel } from "../../../model/login.request.data";
import { CookiesService } from "../../../tools/cookies.service";
import { TradeRequestModel } from "../../../model/trade.request.data";
import { Subscription } from "rxjs";
import { LoginRs } from "../../../interfaces/service.response";

import * as $ from "jquery";
import { WorkspaceServiceService } from "../../../services/workspace-service.service";
import { _ } from "ag-grid";
import { waitForMap } from "@angular/router/src/utils/collection";
import { Utils } from "../../../utils";
import { UserType } from "../../../enums/USerType.enum";
import {AppComponentBase} from "../../../services/AppComponentBase";

declare function myMethod(): any;
export declare var fbq: Function;

@Component({
    selector: "modal-login",
    template: require('./noBounds.component.html'),
    styles: [require('./noBounds.component.css')]
})

export class noBoundsModal extends AppComponentBase  {
    form!: FormGroup;
    protected subscription!: Subscription;

    private _provider: any;
    public get provider(): any {
        return this._provider;
    }
    public set provider(value: any) {
        this._provider = value;
    }


    constructor(
        injector: Injector,
        public activeModal: NgbActiveModal,
        protected ngbModalService: NgbModal,
       
    ) {
        super(injector);
    }

    public jumpToOnda()
    {
        let s = `/api/oauth/request?provider=${this.provider}&sessionKey=${ this.dataService.getSessionKey() }`;
        window.location.href = `/api/oauth/request?provider=OANDA&sessionKey=${ this.dataService.getSessionKey() }`
    }
}
